import { Card } from '../ui/Card';

const SUPPORT_EMAIL = 'mike@anavantistech.com';

export default function Support() {
  return (
    <Card>
      <h1 className="font-display text-3xl font-semibold tracking-tight text-text sm:text-[2rem]">
        Support
      </h1>
      <p className="mt-3 text-sm text-text-muted sm:text-base">
        For technical problems, questions, or feedback, email{' '}
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="text-primary underline hover:text-primary-hover"
        >
          {SUPPORT_EMAIL}
        </a>
        .
      </p>
      <p className="mt-4 text-sm text-text-muted sm:text-base">
        We typically respond within 24 hours.
      </p>
    </Card>
  );
}
